/* @flow */
import type { Node } from 'react';
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import type { TRootState } from '../../types/rootState';
import {
	Content,
	ContentText,
	LivingBanner,
	LivingBannerButton,
	LivingBannerContent,
	LivingBannerImage,
	LivingBannerList,
	LivingBannerText,
	LivingBannerTitle,
	LoaderWrapper,
	ModalTitle,
	Root,
} from '../ModalCallbackDeveloper/styles';
import type { TLiraPopupsState } from '../../reducers/liraPopups';
import { getTextsFromDatabase } from '../../actions/lira';
import type { TDispatch } from '../../types/core';
import { AppContext } from '../AppContext';
import CallbackIcons from '../CallbackIcons';
import { Illustration } from '../ModalCallbackDeveloper/images';
import Button from '../Button2.0';
import { AdvertLink, AdvertLinkPrice, AdvertLinkTitle, AdvertList } from './styles';
import { formatValuesNumber } from '../../utils/formatting';
import type { TApartment } from '../../reducers/apartment';
import type { TApartAdvert } from '../../types/apart';
import Loader from '../Loader';
import { LIRA_SET_CALLBACK_POPUP_ADVERT_TEXTS } from '../../constants';

type TProps = {
	handlerModalToggle: () => {},
};

const ModalCallbackDeveloper = ({ handlerModalToggle }: TProps): Node => {
	const dispatch: TDispatch = useDispatch();
	const store = useStore();
	const context = useContext(AppContext);

	const apartment: TApartment = useSelector((state: TRootState) => state.apartment);
	const liraPopups: TLiraPopupsState = useSelector((state: TRootState) => state.liraPopups);

	const { apartAdvert } = apartment;
	const { popupCallbackAdvertTexts } = liraPopups;

	useEffect(() => {
		if (!popupCallbackAdvertTexts) {
			getTextsFromDatabase(
				'site_popup_ad_cta',
				['promo_block_text', 'promo_block_list', 'ad_text'],
				LIRA_SET_CALLBACK_POPUP_ADVERT_TEXTS,
			)(dispatch, store.getState, context);
		}
	}, []);

	if (popupCallbackAdvertTexts) {
		return (
			<Root>
				{apartAdvert?.length > 0 ? (
					<>
						{popupCallbackAdvertTexts?.adText?.title && (
							<ModalTitle>{popupCallbackAdvertTexts.adText.title}</ModalTitle>
						)}
						<Content>
							{popupCallbackAdvertTexts?.adText?.text && (
								<ContentText>{popupCallbackAdvertTexts.adText.text}</ContentText>
							)}

							<AdvertList>
								{apartAdvert.map((item: TApartAdvert) => (
									<AdvertLink
										key={Math.random()}
										to={item.sourceUrl ? `/external-link/?url=${item.sourceUrl}` : undefined}
										target="_blank"
									>
										<AdvertLinkTitle>
											{item.source === 'AVITO' ? 'Авито' : 'Циан'}&nbsp;#{item.sourceAdvertId}
											&emsp;|&emsp;
											{formatValuesNumber(item.price, 'rub')}
										</AdvertLinkTitle>
										<AdvertLinkPrice>Перейти к объявлению</AdvertLinkPrice>
									</AdvertLink>
								))}
							</AdvertList>
						</Content>
					</>
				) : (
					<ModalTitle>Не нашли ссылку на объявление</ModalTitle>
				)}
				<LivingBanner>
					<LivingBannerContent>
						{popupCallbackAdvertTexts?.promoBlockText?.title && (
							<LivingBannerTitle>{popupCallbackAdvertTexts.promoBlockText.title}</LivingBannerTitle>
						)}
						{popupCallbackAdvertTexts?.promoBlockText?.text && (
							<LivingBannerText>{popupCallbackAdvertTexts.promoBlockText.text}</LivingBannerText>
						)}
						{popupCallbackAdvertTexts?.promoBlockList?.text?.length > 0 && (
							<LivingBannerList>
								{popupCallbackAdvertTexts.promoBlockList.text.map((item) => (
									<li key={Math.random()}>{item}</li>
								))}
							</LivingBannerList>
						)}
						<LivingBannerButton>
							<Button
								id="buttonCallback"
								style={{ padding: '2px 18px', height: '44px', borderColor: 'currentColor' }}
								onClick={() => handlerModalToggle('innerCallback')}
								color="white"
								design="rounded"
								size="xs"
							>
								Обратиться к специалисту
							</Button>
						</LivingBannerButton>
						<CallbackIcons />
					</LivingBannerContent>
					<LivingBannerImage>
						<svg fill="none" viewBox="0 0 211 258">
							{Illustration}
						</svg>
					</LivingBannerImage>
				</LivingBanner>
			</Root>
		);
	}

	return (
		<LoaderWrapper>
			<Loader />
		</LoaderWrapper>
	);
};

export default ModalCallbackDeveloper;
